import React from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import { styles } from "./style";
import Paginator from "../Paginator";
import {
  Form,
  FormControl,
  Button,
  Container,
  Row,
  Col,
  ButtonGroup,
} from "react-bootstrap";
import "./GenericTableFilterBar.css";

class GenericTableFilterBar extends React.Component {
  constructor(props) {
    super(props);
    const query = window.location.search.substring(1);
    this.state = {
      //disableFlag: true
      isDeactivated: query === "deactivated" ? true : false,
    };
  }

  componentWillMount() { }

  componentDidUpdate() {
    //console.log("componentDidUpdate....")
  }

  componentWillUnmount() { }

  actionPerPage = (value) => {
    this.props.setPerPage(value);
  };

  changePage = (value) => {
    this.props.setCurrentPage(value);
  };

  changeSearchText = (e) => {
    this.props.filterRecordsBySearchText(e.target.value);
  };

  filterStatus = (val) => {
    this.props.changeFilterActivationStatus(val);
  };

  render() {
    const {
      showAddIcon,
      showDownloadIcon,
      showExcelExportIcon,
      showCSVExportIcon,
      showPdfExportIcon,
      showDeactivationIcon,
      showSharedContactsIcon,
      title,
      activated,
      deactivated,
      pending,
      filterStatus,
      roleId,
      isSearchVisible = true
    } = this.props;

    const tabbedTitles = [
      "entities",
      "clients",
      "patients",
      "users",
      "mobile app modules",
    ];
    const isTabbedTitle = tabbedTitles.includes(title);
    const showTitleLabel = Boolean(title) && !isTabbedTitle;
    const showTitleColumn = isTabbedTitle || showTitleLabel;
    const paginatorLg = showTitleColumn ? 3 : 8;
    const iconsLg = isSearchVisible ? 2 : showTitleColumn ? 4 : 4;
    const hasIcons = Boolean(
      showDownloadIcon ||
      showExcelExportIcon ||
      showCSVExportIcon ||
      showPdfExportIcon ||
      showDeactivationIcon ||
      showAddIcon ||
      showSharedContactsIcon
    );
    const rowClasses = [
      "filter-bar-row",
      "g-0",
      !showTitleColumn && "filter-bar-row--no-title",
      hasIcons && "filter-bar-row--has-icons",
      isSearchVisible && "filter-bar-row--with-search",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <Container fluid className="generic-table-filter-bar px-0">
        <Row className={rowClasses}>
          {showTitleColumn && (
          <Col lg={5}>
            {showTitleLabel ? (
              <Form.Label
                className="filter-bar-title"
                style={{
                  padding: "13px 0px 0px 13px",
                  fontSize: "17px",
                  color: "#fff",
                  textTransform: "uppercase",
                }}
              >
                {title}
              </Form.Label>
            ) : title === "mobile app modules" ? (
              <ButtonGroup style={{ height: "100%" }}>
                <Button
                  className={css([
                    styles.tabsStyle,
                    filterStatus === 2 ? styles.activatedStyle : "",
                  ])}
                  variant="outline-primary"
                  onClick={() => this.filterStatus(2)}
                >
                  {`${`ACTIVE ${title} (${activated})`}`}
                </Button>
                <Button
                  className={css([
                    styles.tabsStyle,
                    filterStatus === 1 ? styles.pendingStyle : "",
                  ])}
                  variant="outline-primary"
                  onClick={() => this.filterStatus(1)}
                >
                  {`IN-DEVELOPMENT ${title} (${pending})`}
                </Button>
              </ButtonGroup>
            ) : (
              <ButtonGroup style={{ height: "100%" }}>
                {!this.state.isDeactivated && (
                  <>
                    <Button
                      className={css([
                        styles.tabsStyle,
                        filterStatus === 2 ? styles.activatedStyle : "",
                      ])}
                      variant="outline-primary"
                      onClick={() => this.filterStatus(2)}
                    >
                      {`${title === "users"
                        ? `ACTIVE ${title} (${activated})`
                        : `ACTIVATED ${title} (${activated})`
                        }`}
                    </Button>
                    <Button
                      className={css([
                        styles.tabsStyle,
                        filterStatus === 1 ? styles.pendingStyle : "",
                      ])}
                      variant="outline-primary"
                      onClick={() => this.filterStatus(1)}
                    >
                      {`PENDING ${title} (${pending})`}
                    </Button>
                  </>
                )}
                {
                  // (!window.location.pathname.includes("patient") ||
                  //   this.state.isDeactivated
                  //   || roleId !== 3
                  //   ) &&
                  <Button
                    className={css([
                      styles.tabsStyle,
                      filterStatus === 4 ? styles.deactivatedStyle : "",
                    ])}
                    variant="outline-primary"
                    onClick={() => this.filterStatus(4)}
                  >
                    {`DEACTIVATED ${title} (${deactivated})`}
                  </Button>
                }
              </ButtonGroup>
            )}
          </Col>
          )}
          <Col lg={paginatorLg} className="filter-bar-paginator-col">
            <Paginator
              pages={this.props.pages}
              actionPerPage={this.actionPerPage}
              changePage={this.changePage}
              perPage={this.props.perPage}
              currentPage={this.props.currentPage}
            />
          </Col>
          <Col lg={iconsLg} className="filter-bar-icons-col">
            <div className={`${css(styles.iconsDivStyle)} filter-bar-icons`}>
              {showDownloadIcon ? (
                <div>
                  <Button
                    variant="link"
                    onClick={this.props.toggle}
                    className={css(styles.buttonStyle)}
                  >
                    <img
                      src="/images/download_icon.png"
                      alt="download"
                      className={css(styles.imageiconsMenu)}
                    />
                  </Button>
                </div>
              ) : null}

              {showExcelExportIcon ? (
                <div>
                  <Button
                    variant="link"
                    onClick={this.props.excelExport}
                    className={css(styles.buttonStyle)}
                    title="click to export in excel"
                  >
                    <img
                      src="/images/excel.png"
                      alt="excel export"
                      className={css(styles.imageiconsMenu)}
                    />
                  </Button>
                </div>
              ) : null}

              {showCSVExportIcon ? (
                <div>
                  <Button
                    variant="link"
                    onClick={this.props.csvExport}
                    className={css(styles.buttonStyle)}
                    title="click to export in csv"
                  >
                    <img
                      src="/images/csv.png"
                      alt="csv export"
                      className={css(styles.imageiconsMenu)}
                    />
                  </Button>
                </div>
              ) : null}

              {showPdfExportIcon ?
                <div>
                  <Button
                    variant="link"
                    onClick={this.props.pdfExport}
                    className={css(styles.buttonStyle)}
                    title="click to export in pdf"
                  >
                    <img
                      src="/images/pdf-export2.png"
                      alt="pdf export"
                      className={css(styles.imageiconsMenu)}
                    />
                  </Button>
                </div>
                : null
              }

              {/* {showDeleteIcon ? (
                <div>
                    <Button
                    variant="link"
                    onClick={this.props.delete}
                    className={css(styles.buttonStyle)}
                    >
                    <img
                        src="/images/delete.png"
                        alt="new"
                        className={css(styles.imageiconsMenu)}
                    />
                    </Button>
                </div>
                ) : null} */}
              {showDeactivationIcon ? (
                <div>
                  <Button
                    variant="link"
                    title="Deactivation"
                    onClick={this.props.handleDeactivation}
                    className={css(styles.buttonStyle)}
                  >
                    <img
                      src="/images/deactivate_icon.png"
                      alt="deactivation"
                      className={css(styles.imageiconsMenu)}
                    />
                  </Button>
                </div>
              ) : null}
              {showAddIcon ? (
                <div>
                  <Button
                    variant="link"
                    title="Add"
                    onClick={this.props.addNew}
                    className={css(styles.buttonStyle)}
                  >
                    <img
                      src="/images/add_icon.png"
                      alt="new"
                      className={css(styles.imageiconsMenu)}
                    />
                  </Button>
                </div>
              ) : null}
            </div>
          </Col>
         { isSearchVisible && <Col lg={2} className="filter-bar-search-col">
            <Form className="d-flex" style={{ alignItems: "center" }}>
              {/* <img
                    src="/images/search_icon.png"
                    alt="search"
                    style={{ marginRight : "10px"}}
                /> */}
              <FormControl
                type="search"
                placeholder="Search here..."
                className="me-2"
                aria-label="Search"
                onChange={(e) => this.changeSearchText(e)}
              />
            </Form>
          </Col>}
        </Row>
      </Container>
    );
  }
}

export default connect(
  (store) => {
    return {
      perPage: store.tableFilter.perPage,
      currentPage: store.tableFilter.currentPage,
      activated: store.tableFilter.activated,
      deactivated: store.tableFilter.deactivated,
      pending: store.tableFilter.pending,
      filterStatus: store.tableFilter.filterStatus,
      roleId: store.user.roleId,
    };
  },
  (dispatch) => {
    return {
      // filterRecordsBySearchText: (searchText) => {
      //   dispatch({
      //     type: "FILTER_LIST_RECORDS_BY_SEARCH_TEXT",
      //     payload: { searchText },
      //   });
      // },
      setPerPage: (perPage) => {
        dispatch({
          type: "SET_PER_PAGE",
          payload: { perPage },
        });
      },
      setCurrentPage: (currentPage) => {
        dispatch({
          type: "SET_CURRENT_PAGE",
          payload: { currentPage },
        });
      },
      changeFilterActivationStatus: (status) => {
        dispatch({
          type: "SET_FILTER_STATUS",
          payload: { status },
        });
      },
    };
  }
)(GenericTableFilterBar);
